<template>
  <section class="order-1">
    <div class="md:container">
      <Link :href="localeRoute('frontend.index')">
        <img
          src="/frontend/assets/logo.svg"
          class="mt-10 hidden lg:block mx-auto"
        >
      </Link>

      <div class="bg-white lg:mt-10 lg:rounded-2xl px-5 py-7 lg:px-20 lg:py-10 xl:w-4/5 xl:mx-auto">
        <div class="w-full md:w-7/12 mx-auto">
          <div class="flex gap-4 border-b border-gray-100 pb-4">
            <div class="shrink">
              <img
                v-if="vip.content.image"
                :src="vip.content.image.url"
                :alt="vip.content.display_name"
                class="rounded-lg"
                width="218"
                height="218"
              >
            </div>

            <div class="grow">
              <div class="flex flex-col h-full">
                <h1 class="text-xl font-bold md:pt-6 grow">
                  {{ __('vip-order.title', {vip: vip.content.display_name}) }}
                </h1>

                <div
                  v-if="vip.average_delivery_time"
                  class="bg-red-200 text-red px-3 rounded inline w-fit mt-2 text-sm"
                >
                  <i18n-t
                    keypath="vip-order.expected-delivery-time"
                    scope="global"
                  >
                    <template #time>
                      <strong>{{ vip.average_delivery_time }} dagen</strong>
                    </template>
                  </i18n-t>
                </div>
              </div>

              <div
                v-if="currentStep !== null"
                class="flex flex-wrap justify-center mt-4 space-x-4"
              >
                <div class="">
                  <span
                    class="w-[30px] h-[30px] text-white inline-block rounded-full text-center leading-8 font-bold"
                    :class="currentStep === 1 ? 'bg-red' : 'bg-gray-225'"
                  >
                    1.
                  </span>
                  <span
                    class="text inline ml-2 text-lg"
                    :class="currentStep === 1 ? 'text-red' : 'text-gray-225'"
                  >
                    {{ __('vip-order.steps.for-who') }}
                  </span>
                </div>

                <div class="">
                  <span
                    class="w-[30px] h-[30px] text-white inline-block rounded-full text-center leading-8 font-bold"
                    :class="currentStep === 2 ? 'bg-red' : 'bg-gray-225'"
                  >
                    2.
                  </span>
                  <span
                    class="text inline ml-2 text-lg"
                    :class="currentStep === 2 ? 'text-red' : 'text-gray-225'"
                  >
                    {{ __('vip-order.steps.who-are-you') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="failed"
          class="w-full bg-red-500 text-red-100 px-8 py-4 mt-4 text-xl text-center rounded"
        >
          {{ __('vip-order.failed') }}
        </div>

        <slot name="step" />
      </div>

      <div class="flex flex-wrap space-y-6 pb-7 mt-4 lg:content-between lg:space-y-0 xl:w-4/5 xl:mx-auto">
        <div class="text-red w-full text-center lg:w-1/3 lg:text-left">
          <img
            src="/frontend/assets/check-red-border.svg"
            class="inline mr-1"
          >
          <span class="inline">{{ __('vip-order.footer.0') }}</span>
        </div>

        <div class="text-red w-full text-center lg:w-1/3">
          <img
            src="/frontend/assets/check-red-border.svg"
            class="inline mr-1"
          >
          <span class="inline">{{ __('vip-order.footer.1') }}</span>
        </div>

        <div class="text-red w-full text-center lg:w-1/3 lg:text-right">
          <img
            src="/frontend/assets/check-red-border.svg"
            class="inline mr-1"
          >
          <span class="inline">{{ __('vip-order.footer.2') }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    vip: {
      type: Object,
      required: true,
    },

    currentStep: {
      type: Number,
      required: false,
      default: null,
    },

    failed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
